import styled from 'styled-components';

import { grey1, grey10 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { font16 } from 'approot/shared/styles/typography.style';

export const SuggestedAnswerFillInBlanksViewSentence = styled.div`
  ${font16}
  margin-bottom: ${rem(12)};
`;

export const SuggestedAnswerFillInBlanksViewSentenceItems = styled.div`
  ${font16}

  p {
    ${font16}
    margin-bottom: 0;
  }
`;

export const SuggestedAnswerFillInBlanksViewAnswerOuter = styled.div`
  ${font16}
  display: inline;
  margin: 0 ${rem(4)};

  p {
    display: inline;
    margin: 0;
  }
`;

export const SuggestedAnswerFillInBlanksViewAnswer = styled.div`
  ${font16}
  display: inline;

  p {
    display: inline;
    margin: 0;
  }
  text-decoration: underline;
`;

export const SuggestedAnswerFillInBlanksViewAnswerEmpty = styled.div`
  ${font16}

  border-bottom: 1px solid ${grey10};
  min-height: ${rem(24)};
  color: ${grey1};
  display: inline;

  /* This is necessary to fake an inline text element as an 
  empty div otherwise has to be block level and breaks the layout */
  &:before {
    content: 'placeholder';
    color: ${grey1};
  }
`;

export const SuggestedAnswerFillInBlanksText = styled.div`
  ${font16}
  display: inline;

  p {
    display: inline;
  }
`;
